module.exports = __webpack_public_path__ + "img/timesheet-log-book_B09NNDTPZW.7887e7ee.jpg";